<template>
  <div class="dashboard">
    <Top/>
    <v-container class="px-8 py-3" fluid>
      <v-container class="text-center mt-4" v-if="[ ...responseMessage.activeDisplays, ...responseMessage.inactiveDisplays ].length === 0">
        <h1>Informační panely MENDELU</h1>
        <Placeholder />
        <p class="my-3">Nejsou k dispozici žádné obrazovky...</p>
        <p>Pro jejich konfiguraci přejděte do webové administrace.</p>
        <v-btn class="primary mt-10" v-bind:href="administrationUrl" target="blank">Přejít do administrace</v-btn>
      </v-container>
      <h4 v-else class="my-4">Dostupné displeje:</h4>
      <v-layout wrap>
        <v-flex xs12 sm6 md4 lg3
          v-for="(item, idx) in [ ...responseMessage.activeDisplays, ...responseMessage.inactiveDisplays ]"
          :key="`display-${idx}-${item.name}`"
        >
          <v-card outlined class="mr-5 mb-5 dashboard-card">
          <v-card-title class="display-title pb-3">
            <v-chip dark class="ma-0 display-chip" :title="item.name">
              <div class="display-name">{{item.name}}</div>
            </v-chip>
            <v-btn class="display-link" title="Otevřít panel v novém okně" icon v-bind:href="getDisplayUrl(item.id)" target="blank">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </v-card-title>
            <v-card-text v-if="item.announcementTypes.length === 0" class="pb-3">
              Nejsou přiřazeny žádné typy oznámení...
            </v-card-text>
            <v-card-text v-else class="d-flex flex-wrap pb-2">
              <div v-for="(type, idx) in item.announcementTypes" :key="`type-${item.id}-${idx}`" class="content-item" :title="type.title">
                <v-icon :style="{'--base-color': type.color}" class="type-icon">{{type.iconName}}</v-icon>
                <div class="ml-2 mr-1 type-text">
                  {{type.title}}
                </div>
              </div>
            </v-card-text>
            <div class="display-footer d-flex">
              <div class="display-chips">
                <v-chip small class="ml-4 mb-4">Spojení:&nbsp;<b>{{item.connectionsCount}} ×</b></v-chip>
                <v-chip small class="ml-4 mb-4">Perioda:&nbsp;<b>{{item.refreshPeriod}}&nbsp;s</b></v-chip>
              </div>
              <ServiceStatus class="mb-4 mr-6" :color="item.error ? 'red' : 'green'" :text="item.error ? 'chyba' : 'ok'" :description="item.error"/>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container> 
  </div>
</template>

<script>
  import { uuid } from 'vue-uuid';
  import SockJS from "sockjs-client";
  import Stomp from "webstomp-client";
  import {config} from '@/config';
  import ServiceStatus from "./ServiceStatus";
  import Top from "./Top";
  import Placeholder from '../assets/no_displays.svg';

  export default {
    name: "Dashboard",

    components: {
      ServiceStatus,
      Top,
      Placeholder
    },
      
    data() {
      return {
        baseUrl: window.location.protocol + '//' + window.location.host,
        connected: false,
        connectionId: undefined,
        didLoadDashboard: false,
        requestMessage: {
          connectionId: undefined,
        },
        responseMessage: {
          displays: []
        },
      };
    },

    created() {
      this.requestMessage.connectionId = uuid.v4();
      window.addEventListener('beforeunload', this.handler);
      this.connect();
    },

    destroyed() {
      this.handler();
    },

    methods: {
      getDisplayUrl(id) {
        return `${this.baseUrl}/?id=${id}`
      },

      connect() {
        if (this.requestMessage.connectionId) {
          this.socket = new SockJS(config.serverUrl + "socket");
          this.stompClient = Stomp.over(this.socket);
          this.stompClient.connect({}, 
            () => {
              this.connected = true;
              this.stompClient.subscribe(`/displays/dashboard`, message => {
                this.didLoadDashboard = true;
                this.setMessage(message.body);
              });
              if (this.stompClient && this.stompClient.connected) {
                  this.stompClient.send("/app/displays/request-dashboard", JSON.stringify(this.requestMessage), {});
              }
            },
            error => {
                console.error('Socket connection error:', error);
                console.info('Reconnecting websocket in 10 seconds.');

                this.connected = false;
                this.didLoadDashboard = false;

                setTimeout(() => this.connect(), 10000);
            },
          );
        }
      },

      setMessage(msg) {
        if (JSON.stringify(this.responseMessage) !== JSON.stringify(JSON.parse(msg))) {
            this.responseMessage = JSON.parse(msg);
        }
      },

      handler: function handler() {
        if (this.stompClient) {
          this.stompClient.send("/app/displays/disconnect-dashboard", JSON.stringify(this.requestMessage), {});
          this.stompClient.disconnect(); 
        }
        this.connected = false;
      },
    },

    computed: {
      administrationUrl() {
          return config.administrationUrl;
      },
    },
  }
</script>

<style scoped>
  p, h1, h2 {
      color: #3F4349;
  }

  .dashboard-card {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .dashboard {
    background: #FFFFFF;
    color: black;
    width: 100vw;
    height: 100vh;
  }

  .display-footer {
    flex-direction: row;
    justify-content: space-between;
  }

  .display-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .display-chip {
    background-color: #65a61a !important;
    max-width: 75%;
    cursor: pointer;
  }

  .display-name {
    display: block;
    overflow: hidden; 
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .display-link {
    color: rgba(0,0,0,.54) !important;
  }

  .content-item {
    display: block;
    max-width: 90%;
    justify-self: flex-start;
    padding: 0 1rem 0.45rem 0;
  }

  .type-icon {
    float: left;
    background-color: var(--base-color);
    font-size: 1.2em !important;
    padding: 0.3em;
    border-radius: 50%;
    color: white !important;
  }

  .type-text {
    width: -webkit-fill-available;
    margin:  0.2em 1em 0.2em;
    padding-left: 0.7em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
